import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import CircularProgress from '@quintoandar/cozy-core/CircularProgress';

const CIRCULAR_PROGRESS_SIZE = 30;

export const RightFloatedCircularProgress = styled(CircularProgress)`
  float: right;
`;

export const LoadingWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const Loading = ({ isVisible, centered }) => {
  if (!isVisible) {
    return null;
  }

  const size = centered ? 2 * CIRCULAR_PROGRESS_SIZE : CIRCULAR_PROGRESS_SIZE;

  return centered ? (
    <LoadingWrapper>
      <CircularProgress size={size} />
    </LoadingWrapper>
  ) :
    <RightFloatedCircularProgress size={size} />;
};

Loading.defaultProps = {
  centered: false,
};

Loading.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  centered: PropTypes.bool.isRequired,
};
